import FilterAction from "src/components/common/FilterAction";
import {
  Card,
  Col,
  Flex,
  Form,
  Layout,
  Row,
  Select,
  Table,
  TableProps
} from "antd";
import { ColumnsType } from "antd/es/table";
import { get, toNumber } from "lodash";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ActionContent from "src/components/common/ActionContent";
import ModalDeleteConfirm from "src/components/common/ModalDeleteConfirm";
import { apiCaller, cancelListToken } from "src/util/apiCaller";
import {
  getLocalStorage,
  isCheckTable,
  longToDate,
  reDataForTable,
  setLocalStorage,
  StringValueReturn
} from "src/util/Commom";
import { MessageStatusError } from "src/util/MessageStatus";

const listHienThi = [
  { value: "", label: "---Tất cả---" },
  { value: false, label: "Không hiển thị" },
  { value: true, label: "Hiển thị" }
];

const listTheoTuLieu = [
  { value: "isHinhAnh", label: "Hình ảnh" },
  { value: "isVideo", label: "Video" },
  { value: "isTuLieu", label: "Tư liệu" }
];

const DanhSachGopY = ({ status }: any) => {
  const { isActive } = status;
  const [isLoadTable, setIsLoadTable] = useState<boolean>(false);
  const [datatable, setDatatable] = useState([]);
  const [total, setTotal] = useState(0);
  const [activePage, setActivePage] = useState(1);
  const pageSize = 10;
  const navigate = useNavigate();
  const FormItem = Form.Item;
  const [form] = Form.useForm();
  const [listTuLieu, setListTuLieu] = useState([]);
  const [isLoadingTuLieu, setIsLoadingTuLieu] = useState(false);
  const [idTuLieu, setIdTuLieu] = useState(undefined);
  const [isHienThi, setIsHienThi] = useState("");
  const [theoTuLieu, setTheoTuLieu] = useState(undefined);
  const { setFieldsValue } = form;
  const [isSearchClick, setIsSearchClick] = useState(false);

  useEffect(() => {
    if (isActive) {
      const state = getLocalStorage("dataFilter") || undefined;
      if (state) {
        setIdTuLieu(state.idTuLieu);
        setActivePage(state.activePage);
        setIsHienThi(state.isHienThi);
        setTheoTuLieu(state.theoTuLieu);
        setFieldsValue({ gopy: state });

        if (state.theoTuLieu === "isTuLieu") {
          getTuLieu(true, false, false);
        } else if (state.theoTuLieu === "isVideo") {
          getTuLieu(false, true, false);
        } else if (state.theoTuLieu === "isHinhAnh") {
          getTuLieu(false, false, true);
        }
        getListData(state.activePage, state.idTuLieu, state.isHienThi);
      } else {
      getListData(activePage, idTuLieu, isHienThi);
      }
    } else {
      navigate("/error/401");
    }
  }, []);

  useEffect(() => {
    return () => {
      cancelListToken(["listDanhSachGopY"]);
    };
  }, []);

  /**
   * getListData: getlist chức vụ
   * @param {string} keyword
   * @param {int} activePage
   * @memberof DanhSachGopY
   */
  const getListData = async (
    activePage: number,
    idTuLieu: any,
    isHienThi: any
  ) => {
    setIsLoadTable(true);
    const configAPI = {
      url: `api/tulieugopys?page=${activePage}&size=${pageSize}&idtulieu=${
        idTuLieu || ""
      }&ishienthi=${isHienThi}`,
      method: "GET",
      value: null,
      apiType: "LIST",
      getName: "listDanhSachGopY"
    } as any;
    const response = await apiCaller(configAPI);
    try {
      if (
        response?.data &&
        (response.status === 200 || response.status === 201)
      ) {
        const data = reDataForTable(
          get(response.data, "content", []),
          activePage,
          pageSize
        );
        setDatatable(data as any);
        setTotal(get(response.data, "totalElements", 0));
        setIsLoadTable(false);
      } else {
        MessageStatusError(toNumber(response?.status));
      }
    } finally {
      setIsLoadTable(false);
    }
  };

  const onChangeTheoTuLieu = (e: any) => {
    if (e === "isTuLieu") {
      getTuLieu(true, false, false);
    } else if (e === "isVideo") {
      getTuLieu(false, true, false);
    } else if (e === "isHinhAnh") {
      getTuLieu(false, false, true);
    }
    setTheoTuLieu(e);
  };

  const getTuLieu = async (
    istulieu: boolean,
    isvideo: boolean,
    ishinhanh: boolean
  ) => {
    setIsLoadingTuLieu(true);
    const configAPI = {
      url: `api/tulieus?page=0&istulieu=${istulieu}&isvideo=${isvideo}&ishinhanh=${ishinhanh}`,
      method: "GET",
      value: null,
      apiType: "LIST",
      getName: "listTuLieuFile"
    } as any;
    const response = await apiCaller(configAPI);
    try {
      if (
        response?.data &&
        (response.status === 200 || response.status === 201)
      ) {
        const data = get(response.data, "content", []);
        setListTuLieu(data as any);
        setIsLoadingTuLieu(false);
      } else {
        MessageStatusError(toNumber(response?.status));
      }
    } finally {
      setIsLoadingTuLieu(false);
    }
  };

  const columnsGopY: ColumnsType<any> = [
    {
      title: "STT",
      dataIndex: "key",
      key: "key",
      width: "5%",
      align: "center",
      render: (text, record, index) => <span>{index + 1}</span>
    },
    {
      title: "Tên tài liệu",
      dataIndex: "tuLieu",
      key: "tuLieu",
      render: (text, record) => <span>{text.tenTuLieu}</span>
    },
    {
      title: "Tên người góp ý",
      dataIndex: "nguoiGopY",
      key: "nguoiGopY",
      width: "15%"
    },
    { title: "Email", dataIndex: "email", key: "email", width: "20%" },
    {
      title: "Ngày góp ý",
      dataIndex: "ngayGopY",
      key: "ngayGopY",
      width: "10%",
      render: (item) => longToDate(item)
    },
    {
      title: "Hiển thị",
      dataIndex: "isHienThi",
      key: "isHienThi",
      align: "center",
      width: "8%",
      render: (item) => isCheckTable(item)
    },
    {
      title: "Hành động",
      dataIndex: "",
      key: "x",
      align: "center",
      width: "10%",
      render: (item) => actionContent(item)
    }
  ];

  /**
   * actionContent: Hành động trên bảng
   * @param {object} item
   * @memberof DanhSachGopY
   */
  const actionContent = (item: object) => {
    return (
      <ActionContent
        onDeleteItem={() => deleteItemFunc(item)}
        onEditItem={() => handleRedirect("edit", item)}
      />
    );
  };

  /**
   * deleteItemFunc: Xoá item theo item
   * @param {object} item
   * @memberof DanhSachGopY
   */
  const deleteItemFunc = (item: object) => {
    ModalDeleteConfirm(deleteItemAction, item);
  };

  /**
   * deleteItemAction: Xóa item
   * @param {object} item
   * @memberof DanhSachGopY
   */
  const deleteItemAction = async (item: any) => {
    const config = {
      url: `api/tulieugopy/${item.id}`,
      apiType: "DELETE",
      value: null,
      method: "DELETE",
      getName: "deleteGopY"
    };
    const response = await apiCaller(config);
    try {
      if (response?.status === 200 || response?.status === 201) {
        const dataPage = total - (activePage - 1) * pageSize;
        const page = dataPage <= 1 && total !== 1 ? activePage - 1 : activePage;
        getListData(page, idTuLieu, isHienThi);
        setIsLoadTable(true);
      } else {
        MessageStatusError(toNumber(response?.status));
      }
    } catch (error) {
      setIsLoadTable(false);
      // Xử lý lỗi khi lưu dữ liệu không thành công
    }
  };

  /**
   * handleRedirect: Chuyển trang thêm mới và chỉnh sửa
   * @param {string} type
   * @param {object} item
   * @memberof DanhSachGopY
   */
  const handleRedirect = (type = "", item: any) => {
    let pathname = "/quan-tri";
    switch (type) {
      case "edit":
        pathname += `/${item.id}/tra-loi-gop-y/idtulieu/${item.tuLieu.id}`;
        break;
      default:
        break;
    }
    navigate(pathname, { state: { itemData: item } });
    if(isSearchClick){
      const content = {
        activePage,
        pageSize,
        theoTuLieu,
        idTuLieu,
        isHienThi,
        pathname: "quan-tri/tra-loi-gop-y"
      };
      setLocalStorage("dataFilter", content);
    }
  };

  /**
   * handleTableChange: Fetch dữ liệu dựa theo thay đổi trang
   * @param {object} pagination
   * @memberof DanhSachGopY
   */
  const handleTableChange: TableProps["onChange"] = (pagination) => {
    const activePage = pagination.current as number;
    getListData(activePage, idTuLieu, isHienThi);
    setActivePage(activePage);
  };

  /**
   * expandRow: Hiển thị dữ liệu khi expand row
   * @param {object} item
   * @memberof QuanLyKeHoachList
   */
  const expandRow = (item: any) => (
    <Row gutter={18}>
      <StringValueReturn
        text="Nội dung góp ý"
        type="text"
        value={item.noiDungGopY}
      />
    </Row>
  );

  const onChangeTuLieu = (value: any) => {
    setIdTuLieu(value);
  };

  const onChangeHienThi = (e: any) => {
    setIsHienThi(e);
  };

  const handleSubmit = () => {
    setIsSearchClick(true);
    getListData(activePage, idTuLieu, isHienThi);
  };
  const handleReset = () => {
    setTheoTuLieu(undefined);
    setFieldsValue({
      gopy: {
        theoTuLieu: undefined,
        isHienThi: "",
        idTuLieu: undefined
      }
    });
    setIdTuLieu(undefined);
    setIsHienThi("");
  };
  return (
    <Layout>
      <Flex justify="space-between" align="center">
        <h3 style={{ color: "black", fontSize: 20 }}>Danh sách góp ý</h3>
      </Flex>
      <Card className="th-card-margin-bottom">
        <Form layout="vertical" form={form} name="quyen-control">
          <Col>
            <Row gutter={16} style={{ marginTop: -2 }}>
              <Col md={8} xs={24}>
                <FormItem
                  className="ant-input-group"
                  label="Tìm theo loại tư liệu"
                  name={["gopy", "theoTuLieu"]}
                  initialValue={theoTuLieu}
                >
                  <Select
                    allowClear
                    showSearch
                    onChange={onChangeTheoTuLieu}
                    placeholder="Chọn theo tư liệu"
                    style={{ width: "100%" }}
                    options={listTheoTuLieu}
                    optionFilterProp="label"
                    filterOption={(input, option: any) =>
                      (option?.label ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    fieldNames={{ label: "label", value: "value" }}
                  />
                </FormItem>
              </Col>
              <Col md={8} xs={24}>
                <FormItem
                  className="ant-input-group"
                  label="Tư liệu"
                  name={["gopy", "idTuLieu"]}
                  initialValue={idTuLieu || undefined}
                >
                  <Select
                    allowClear
                    showSearch
                    disabled={!theoTuLieu}
                    onChange={onChangeTuLieu}
                    placeholder="Chọn tư liệu"
                    style={{ width: "100%" }}
                    loading={isLoadingTuLieu}
                    options={listTuLieu}
                    optionFilterProp="tenTuLieu"
                    filterOption={(input, option: any) =>
                      (option?.tenTuLieu ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    fieldNames={{ label: "tenTuLieu", value: "id" }}
                  />
                </FormItem>
              </Col>
              <Col md={8} xs={24}>
                <FormItem
                  className="ant-input-group"
                  label="Hiển thị góp ý"
                  name={["gopy", "isHienThi"]}
                  initialValue={isHienThi}
                >
                  <Select
                    allowClear
                    showSearch
                    onChange={onChangeHienThi}
                    placeholder="Chọn trường hợp hiển thị"
                    style={{ width: "100%" }}
                    options={listHienThi}
                    fieldNames={{ label: "label", value: "value" }}
                  />
                </FormItem>
              </Col>
              <Col md={8} xs={24}>
                <FilterAction search={handleSubmit} reset={handleReset} />
              </Col>
            </Row>
          </Col>
        </Form>
      </Card>
      <Card style={{ marginTop: 10 }}>
        <Table
          style={{ marginBottom: 20 }}
          rowKey={"id"}
          bordered
          columns={columnsGopY}
          className="qti-table-wrapper gx-table-responsive"
          expandRowByClick={true}
          expandedRowRender={expandRow}
          dataSource={datatable}
          rowClassName={(record, index) =>
            index % 2 === 0 ? "qti-table-row-background" : ""
          }
          size="middle"
          pagination={{
            current: activePage,
            pageSize,
            total,
            showSizeChanger: false,
            showQuickJumper: false,
            showTotal: (total) =>
              pageSize <= total
                ? `Hiển thị ${pageSize} trong tổng ${total}`
                : `Tổng ${total}`
          }}
          loading={isLoadTable}
          onChange={handleTableChange}
        />
      </Card>
    </Layout>
  );
};
export default DanhSachGopY;
